'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _base = require('base');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Checkbox = function (_BaseField) {
	_inherits(Checkbox, _BaseField);

	function Checkbox() {
		_classCallCheck(this, Checkbox);

		return _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
	}

	_createClass(Checkbox, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			return React.createElement(
				'label',
				{ 'data-checkbox': this.props.asToggle ? 'toggle' : 'checkbox', className: this.props.className },
				React.createElement(
					'span',
					{ className: 'checkbox-wrap' },
					React.createElement('input', { type: 'checkbox', checked: this.getValue() || false, onChange: function onChange(event) {
							return _this2.updateValue(event.target.checked, true);
						} }),
					React.createElement('i', null)
				),
				React.createElement(
					'span',
					null,
					this.props.label
				)
			);
		}
	}], [{
		key: 'value',
		value: function value(data, trueValue, falseValue) {
			if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) == 'object') {
				if (data.id == trueValue) return true;
				if (data.id == falseValue) return false;
			}

			return null;
		}
	}, {
		key: 'updateValue',
		value: function updateValue(updater, trueValue, falseValue) {
			return function (value) {
				if (value === true) {
					updater({ id: trueValue, value: 'Yes' });
					return;
				}
				if (value === false) {
					updater({ id: falseValue, value: 'No' });
					return;
				}
				updater(null);
				return;
			};
		}
	}]);

	return Checkbox;
}(_base2.default);

exports.default = Checkbox;